export default {
  passwordLengthValidation: 'Al menos 8 caracteres.',
  passwordUpperCaseValidation: 'Al menos 1 mayúscula.',
  passwordLowerCaseValidation: 'Al menos 1 minúscula.',
  passwordNumberCaseValidation: 'Al menos 1 número.',
  passwordCharacterValidation: 'Al menos 1 carácter especial.',
  allDone: 'Tu contraseña es segura.',
};
